import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import "./style.css";
import { useDashboardStore } from "@/stores/dashboard";

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);
const dashboardStore = useDashboardStore(pinia);
dashboardStore.init().finally(() => {
  app.mount("#app");
});
// initialize store data (shortcuts from server or fallback)
// mounted in init callback
